<script setup lang="ts">
import type {ReplacementCandidate} from '../../types/replacement_detection';

defineProps<Pick<ReplacementCandidate, 'source' | 'dest' | 'similarity'>>();

const checked = defineModel<boolean>('checked', {required: true});
</script>

<template>
  <div class="replacement-item-container">
    <label class="item-label">
      <input
        v-model="checked"
        class="tw:shrink-0"
        type="checkbox"
      >
      <span class="item-filenames">
        <span class="old-filename">{{ source }}</span>
        <span class="tw:text-text-light-3"> → </span>
        <span class="new-filename">{{ dest }}</span>
      </span>
      <span
        class="similarity-label ui label"
        :class="similarity >= 0.8 ? 'green' : similarity >= 0.5 ? 'yellow' : 'grey'"
      >
        {{ Math.round(similarity * 100) }}%
      </span>
    </label>
  </div>
</template>

<style scoped>
@reference "#index.css";

.replacement-item-container {
  @apply tw:py-2 tw:border-b tw:border-solid tw:border-secondary-alpha-40 tw:last:border-b-0;
}

.item-label {
  @apply tw:flex tw:items-center tw:gap-2 tw:cursor-pointer;
}

.item-filenames {
  @apply tw:font-mono tw:min-w-0 tw:wrap-anywhere;
}

.old-filename {
  @apply tw:text-text-light-2 tw:line-through;
}

.similarity-label {
  @apply tw:flex-shrink-0 tw:text-xs tw:ml-auto;
}
</style>
